export default [
    {
      id: 0,
      img:
        "https://images.squarespace-cdn.com/content/v1/57645625f5e231759e260acf/1492787814435-W5WKPE4KSW1B1N70I31O/Richard",
      name: "Richard Hendricks",
      title: "Founder/CEO",
      office: "203-232-3455",
      mobile: "453-245-5332",
      sms: "202-343-2567",
      email: "richard@gmail.com",
      
    },
    {
      id: 1,
      img:
        "https://www.thewrap.com/wp-content/uploads/2019/02/Woods-Cropped-Headshot-1.jpg",
      name: "Jared Dunn",
      title: "Assistant",
      office: "203-843-2355",
      mobile: "487-245-2356",
      sms: "332-343-3123",
      email: "Jared@gmail.com",
    },
    {
      id: 2,
      img:
        "https://www.indiewire.com/wp-content/uploads/2021/10/Kumail-Nanjiani.jpg?w=780",
      name: "Dinesh",
      title: "Java programmer",
      office: "203-843-2355",
      mobile: "487-245-2356",
      sms: "332-343-3123",
      email: "Dinesh@gmail.com",
    },
    {
      id: 3,
      img:
        "http://detroitcast.com/wp-content/uploads/2017/05/martin-starr-512x512.jpg",
      name: "Gilfoyle",
      title: "Software engineer/ Architect",
      office: "874-232-3455",
      mobile: "353-245-5332",
      sms: "703-343-2567",
      email: "Gilfoyle@gmail.com",
    },
    {
      id: 4,
      img: "https://www.thewrap.com/wp-content/uploads/2016/10/TJ-Miller.jpg",
      name: "Erlic Backman",
      title: "PR person",
      office: "323-232-3455",
      mobile: "839-245-5332",
      sms: "989-343-2567",
      email: "Erlick.B@gmail.com",
    }, 
    {
      id: 5,
        img:"https://healthyceleb.com/wp-content/uploads/2019/11/Amanda-Crew-as-seen-in-a-picture-showing-her-new-hair-in-April-2017.jpg",
        name: "Monica",
        title: "Board member",
        office: "203-843-2355",
        mobile: "487-245-2356",
        sms: "332-343-3123",
        email: "Monica@gmail.com",
    }, 
    {
      id: 6,
        img: "https://nlk.bmscdn.com/Artist/791.jpg",
        name: "Nelson Bighetti",
        title: "Professor",
        office: "703-232-3455",
        mobile: "234-567-5332",
        sms: "202-343-7837",
        email: "Bighead@gmail.com",
    }
  ];
  